/* 初始化JSbridge */
function connectWebViewJavascriptBridge(callback) {
    //alert('WebViewJavascriptBridge-----------'+window.WebViewJavascriptBridge)
    if (window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge)
    } else {
        document.addEventListener('WebViewJavascriptBridgeReady', function() {
            //alert('注册-----------'+window.WebViewJavascriptBridge)
            callback(window.WebViewJavascriptBridge)
        }, false)
    }
}

connectWebViewJavascriptBridge(function(bridge) {
    bridge.init(function(message, responseCallback) {
        console.log(message, responseCallback)
    })
});

/*通过客户端方法判断看是登录  去取客户端交易账号登录信息  客户端登录有返回  未登录 请求行情账号登录信息*/
function isLoginFlag(callBack, callBack2) {
    // var wt = isIos() ? 'wt' : 'wt_pt'
    var wt = 'wt'
    var data = {
        info_type: wt,
        call_type: 'fetch',
    }
    connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('getUserInfoByRsa', data, function (response) {
            console.log(response, '===wt登录')
            if (response && response.login_status == '0') { //0 没登录
                // 交易账号未登录，获取行情账号登录状态
                isHqLoginFlag(callBack2)
            } else {
                callBack(response)
            }
        })
    })
}

/*通过客户端方法判断看是登录  去取客户端行情账号登录信息  客户端登录有返回  未登录 不做任何操作*/
function isHqLoginFlag(callBack) {
    connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('isLoginHQ', {}, function (response) {
            console.log(response, '===hq登录')
            if (response && response.login_status == '0') { //0 没登录
                //没有登录
                callBack('0')
            } else {
                callBack(response)
            }
        })
    })
}

/** 
 * 客户端方法调用委托登录页面  客户端未登录 调用起登录 ， 已登录 则返回数据
 * @type wt:委托账号登录   hq: 行情账号登录
 * */
function isLoginIOSAnd(callback, redirectUrl, type) {

	// d = d || '';
	// d = JSON.stringify(d)
    // var fun = 'javascript:AppCalBackFun(' + d + ')';
    // var wt = isIos() ? 'wt' : 'wt_pt'
    var wt = type || 'wt'
	var data = {
		info_type: wt,
		call_type: 'callback_after_login',
		// callback_url: fun,
	}
	//calltype  login 唤起登录的； fetch 获取登录信息
	connectWebViewJavascriptBridge(function (bridge) {
		bridge.callHandler('getUserInfoByRsa', data, function (response) {
            console.log(response, '==='+wt)
			if (response && response.login_status == '0') { //0 没登录
				//没有登录
			} else {
                callback(response, redirectUrl)
			}
		})
	})
}

/* 获取当日盈亏信息 */
function getAssetInfo (callback) {
    connectWebViewJavascriptBridge(function (bridge) {
		bridge.callHandler('getAssetInfor', {}, function (response) {
			if (response && response.code == '0') { //0 没登录
				//没有登录
			} else {
                callback(response)
			}
		})
	})
}

/**
 * 夜间模式切换
 * @param 0:白天   1:黑夜
 */
function changeTheme (type, callback) {
    connectWebViewJavascriptBridge(function (bridge) {
        console.log(type)
        bridge.callHandler('setThemeMode', {'themeMode': type}, function (response) {
            console.log(response, 'theme')
            callback(response)
		})
    })
}

/* 获取资产信息 */
function getPersonalAssetInfo (responseCallback) { // app获取接口数据后通过window.getPersonalAssetInfo() 方法返回数据
    var data = {
        action: 'getPersonalInfo'
    }
    connectWebViewJavascriptBridge(function (bridge) {
        if (isIos()) {
            bridge.registerHandler('getPersonalAssetInfo', function(data) {
                console.log(data, '===获取资产信息')
                if (data && data.code == '1') {
                    responseCallback(data)
                }
            })
        }
		bridge.callHandler('getPersonalAssetInfo', data, function (data) {
            console.log(data, '===获取资产信息')
            responseCallback(data)
        })
	})
}

/* 获取未读消息数量 */
function getUnreadNum (callback) {
    connectWebViewJavascriptBridge(function (bridge) {
        if (isIos()) {
            bridge.registerHandler('getUserMessageNum', function(data) {
                console.log(data, '===获取未读消息')
                callback(data)
            })
        }
        bridge.callHandler('getUserMessageNum', {}, function(response) {
            console.log(response, '===获取未读消息')
            callback(response)
        })
    })
}

/* 登出 */
function wtLogOut() {
    connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('wtLogOut', {}, function() {})
    })
}

function isIos () {
    return !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

/*获取定位信息*/
function getAppStorage(callBack,paramName) {
    if(!paramName){
        return;
    }
    connectWebViewJavascriptBridge(function (bridge) {
        if (isIos()) {
            bridge.registerHandler('getAppStorage', function(data) {
                console.log(data, '===获取APP信息')
                callBack(data)
            })
        }
        bridge.callHandler('getAppStorage', {"paramName":paramName}, function (response) {
            console.log(response, '===获取APP信息')
            callBack(response)
        })
    })
}

/*拨打电话*/
function callPhone(tel) {
    window.location.href="tel:"+tel;
}


function callWebview(funcNo,paramName) {
    if(!paramName){
        paramName={};
    }
    connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler(funcNo, paramName, function (response) {
            console.log(response);
		})
    })

    // connectWebViewJavascriptBridge(function (bridge) {
    //     bridge.callHandler("goBack", {type:"component"}, function (response) {
    //         console.log(response);
	// 	})
    // })
}

export  {
    isLoginFlag,
    isHqLoginFlag,
    isLoginIOSAnd,
    getAssetInfo,
    getPersonalAssetInfo,
    wtLogOut,
    getUnreadNum,
    changeTheme,
    isIos,
    getAppStorage,
    callPhone,
    callWebview
}
